import React, { useEffect, useState } from 'react';
import Plot from 'react-plotly.js';
import axiosInstance from '../utils/axiosInstance';
import { plotlyStyle } from '../utils/plotlyStyle';
import {
  Stack,
  Typography,
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
import { MESSAGES } from '../constants/messages';

const ChartOrderAmountDistribution = () => {
  const [month, setMonth] = useState(dayjs());

  const [amountData, setAmountData] = useState([]);

  const [loading, setLoading] = useState(true);

  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAmountData = async () => {
      setLoading(true);

      try {
        const res = await axiosInstance.get(
          '/chart/order-amount-distribution',
          {
            params: {
              month: month.format('YYYY-MM'),
            },
          }
        );

        setAmountData(res.data);
        setError(null);
      } catch (err) {
        setError('データの取得に失敗しました');
      } finally {
        setLoading(false);
      }
    };

    fetchAmountData();
  }, [month]);

  if (loading) {
    return (
      <Typography>
        {MESSAGES.LOADING}
      </Typography>
    );
  }

  if (error) {
    return (
      <Typography>
        {error || MESSAGES.LOAD_FAILED}
      </Typography>
    );
  }

  const scatterData = {
    x: amountData.map(item =>
      Number(item.order_number)
    ),

    y: amountData.map(item =>
      Number(item.total_amount)
    ),

    type: 'scatter',

    mode: 'markers',

    name: '注文金額',

    marker: {
      color: plotlyStyle.colors.bar,
      size: 7,
    },

    hovertemplate:
      '注文番号: %{x}<br>' +
      '金額: %{y:,.0f}円' +
      '<extra></extra>',
  };

  const scatterLayout = {
    ...plotlyStyle.layout,

    title: {
      text:
        `${month.format('YYYY年M月')} 注文金額の分布`,
    },

    xaxis: {
      ...plotlyStyle.layout.xaxis,

      title: '注文番号',

      tickformat: 'd',

      showticklabels: false,
    },

    yaxis: {
      ...plotlyStyle.layout.yaxis,

      title: '金額 (円)',

      tickformat: ',.0f',
    },

    margin: {
      l: 80,
      r: 20,
      t: 50,
      b: 50,
    },
  };

  return (
    <>
      <Stack spacing={2} sx={{ mb: 2 }}>
        <LocalizationProvider
          dateAdapter={AdapterDayjs}
          adapterLocale="ja"
        >
          <DatePicker
            views={['year', 'month']}
            label="対象月"
            value={month}
            onChange={setMonth}
            slotProps={{
              textField: {
                size: 'small',
              },
            }}
            format="YYYY年M月"
          />
        </LocalizationProvider>
      </Stack>

      <div>
        <Plot
          data={[scatterData]}
          layout={scatterLayout}
          style={{
            width: '100%',
            height: '100%',
            minHeight: 500,
          }}
          useResizeHandler
          config={{
            responsive: true,
            displayModeBar: false,
          }}
        />
      </div>
    </>
  );
};

export default ChartOrderAmountDistribution;